var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"columns"},[(_vm.$auth.check())?_c('div',{staticClass:"column is-2 menu-settings"},[_c('backend-menu')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }